<script setup lang="ts">
const store = useSongStore();
const song = computed(() => store.data);
const translations = computed(() => song.value?.translations);
const status = computed(() => store.status);

const shown = computed(() => {
  if (
    status.value === LoadStatus.Ready &&
    store.song?.products.general.authorized &&
    !song.value?.translations?.length
  ) {
    return false;
  }
  return true;
});
</script>

<template>
  <section
    class="col-12 col-sm-6"
    v-if="shown"
  >
    <SectionTitle :placeholder="store.placeholderNotLoaded">{{
      $t("S.LIT_Translations")
    }}</SectionTitle>
    <div v-if="store.placeholderNotAuthorized">
      <Placeholder
        :min-width="100"
        :max-width="250"
      />
    </div>
    <div v-else>
      <div
        v-for="(t, i) of translations"
        :key="i"
      >
        <router-link
          :to="`/songs/${t.songNumber}/${t.slug}`"
          class="link text-primary"
          >{{ t.title }} ({{ t.language }})</router-link
        >
      </div>
    </div>
  </section>
</template>

<style scoped lang="postcss"></style>
